import * as React from "react";
import { ApiError, apiErrorDetail } from "@hp/api-client";

export function LoadingState({ label = "Loading..." }: { label?: string }) {
  return (
    <div className="flex items-center gap-2 rounded-md border border-slate-200 bg-white px-4 py-6 text-sm text-slate-500">
      <span
        className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-slate-300 border-t-brand-600"
        aria-hidden
      />
      {label}
    </div>
  );
}

export function ErrorState({ error, label = "Something went wrong" }: { error: unknown; label?: string }) {
  const message =
    error instanceof ApiError
      ? apiErrorDetail(error) ?? error.message
      : error instanceof Error
        ? error.message
        : String(error);
  return (
    <div className="rounded-md border border-red-200 bg-red-50 px-4 py-4 text-sm text-red-700">
      <p className="font-medium">{label}</p>
      <p className="mt-1 text-red-600">{message}</p>
    </div>
  );
}

export function EmptyState({ children }: { children: React.ReactNode }) {
  return (
    <div className="rounded-md border border-dashed border-slate-300 bg-white px-4 py-8 text-center text-sm text-slate-400">
      {children}
    </div>
  );
}
